import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'form',
    'method',
    'list',
    'payment',
    'success',
    'membershipName',
    'membershipPlan',
    'membershipBenefit',
    'membershipBtn',
    'paymentForm',
    'membershipSubmitBtn',
    'ageAgree',
  ];

  static values = { slug: String };

  connect() {}

  add({ params: { slug } }) {
    const form = this.formTarget;
    form.action = `/g/${slug}/admin/membership/add`;
    form.submit();
  }

  delete({ params: { slug, id } }) {
    const form = this.formTarget;
    const methodInput = this.methodTarget;

    methodInput.value = 'delete';
    form.action = `/g/${slug}/admin/membership/${id}`;
    form.submit();
  }

  select({ params: { joinUrl, id, name, plan, benefit } }) {
    this.listTarget.classList.add('hidden');
    this.paymentTarget.classList.remove('hidden');

    this.setText(joinUrl, id, name, plan, benefit);
  }

  cancel() {
    this.paymentTarget.classList.add('hidden');
    this.listTarget.classList.remove('hidden');
  }

  setText(joinUrl, id, name, plan, benefit) {
    if (plan == '0') {
      this.membershipSubmitBtnTarget.classList.remove('hidden');
      this.membershipBtnTarget.classList.add('hidden');
      this.paymentFormTarget.action = joinUrl;
      this.ageAgreeTarget.classList.add('hidden');
    } else {
      this.membershipSubmitBtnTarget.classList.add('hidden');
      this.membershipBtnTarget.classList.remove('hidden');
      this.membershipBtnTarget.setAttribute('data-payment-membership-id-param', id);
      this.ageAgreeTarget.classList.remove('hidden');
    }

    this.membershipNameTargets.forEach((t) => {
      t.textContent = name;
    });

    this.membershipPlanTarget.textContent = plan.toLocaleString('ko-KR');
    this.membershipBenefitTarget.innerHTML = benefit;
  }
}
